import React, { createContext, useReducer } from 'react';
import { InboundDataReducer } from '../reducers/InboundDataReducer';

export const InboundDataContext = createContext();

const initialState = {
    pphData: null,
    downtimeData: null,
    qualityData: null,
    qualityDataError: null,
    stowMetrics: null,
    stowMetricsError: null,
    loading: false,
    error: null
};

export const InboundDataProvider = ({ children }) => {
    const [viewModel, dispatch] = useReducer(InboundDataReducer, initialState);

    return (
        <InboundDataContext.Provider value={{ viewModel, dispatch }}>
            {children}
        </InboundDataContext.Provider>
    );
};



// WEBPACK FOOTER //
// ./src/components/inbound/context/InboundDataContext.js